import styled from 'styled-components'

export const SectionContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
`

export const SectionWrap = styled.div`
	width: 100%;
	max-width: 420px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
`
export const LoginWrapper = styled.div`
	width: 100%;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 20px;
	box-shadow: 
		0 8px 32px rgba(0, 0, 0, 0.3),
		inset 0 1px 0 rgba(255, 255, 255, 0.08);
	padding: 50px 45px;
	border: 1px solid rgba(255, 255, 255, 0.08);
	backdrop-filter: blur(10px);
	position: relative;
`

export const LoginSubContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	justify-content: center;
	margin-top: 30px;
`

export const ForgotPassword = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 5px;
`
export const TermOfService = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	width: 250px;
`

export const LoginWidth = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 20px;
`

// eslint-disable-next-line prettier/prettier
export const Divider = styled.div<{ color: string }>`
	flex: 1;
	height: 1px;
	background-color: ${props => props.color};
`

export const TabContainer = styled.div`
	margin-bottom: 8px;
	display: flex;
	justify-content: space-around;
	align-items: center;
`

// eslint-disable-next-line prettier/prettier
export const BtnContainer = styled.div<{
	bgColor?: string
	boxShadow?: string
}>`
	color: white;
	padding: 0;
	border-radius: 10px;
	outline: 0;
	margin-top: 30px;
	margin-bottom: 10px;
	display: flex;
	cursor: pointer;
	justify-content: center;
	width: 100%;
	background: linear-gradient(135deg, #4c6ef5 0%, #5c7cfa 100%);
	box-shadow: 0 4px 15px rgba(76, 110, 245, 0.3);
	transition: all 0.3s ease;
	position: relative;
	
	&:hover {
		background: linear-gradient(135deg, #364fc7 0%, #4c6ef5 100%);
		transform: translateY(-1px);
		box-shadow: 0 6px 20px rgba(76, 110, 245, 0.4);
	}
	
	&:active {
		transform: translateY(0);
		box-shadow: 0 2px 10px rgba(76, 110, 245, 0.3);
	}
	
	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
		background: #4a5568;
		box-shadow: none;
		transform: none;
	}
`
